<template>
  <div>
    <v-row class="ma-4 mt-2" no-gutters>
      <v-col
        v-if="step == stepCount && dataGet.settings.submitbutton.enabled"
        cols="12"
      >
        <v-btn
          large
          color="cyan"
          :loading="submitLoading"
          dark
          rounded
          block
          @click="postData"
        >
          {{ dataGet.settings.submitbutton.text }}
          <v-icon>mdi-check-bold</v-icon>
        </v-btn>
      </v-col>
      <v-col v-else cols="12">
        <v-btn-toggle dark style="width: 50%">
          <v-btn
            block
            :disabled="step <= 1 && !dataGet.settings.previousbutton.enabled"
            @click="changeStep(step - 1, true)"
          >
            <v-icon>mdi-arrow-right</v-icon>
            {{ dataGet.settings.previousbutton.text }}
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!dataGet.settings.nextbutton.enabled"
            dark
            block
            @click="changeStep(step + 1)"
          >
            {{ dataGet.settings.nextbutton.text }}
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-snackbar v-model="isToast" color="error">
      {{ toast }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Submit",
  props: ["dataField"],
  computed: {
    dataGet: {
      get() {
        return this.$store.state.dataGet;
      },
    },
    submitLoading: {
      get() {
        return this.$store.state.submitLoading;
      },
    },
    step: {
      get() {
        this.$store.commit("updateStep", this.$store.state.step);
        return this.$store.state.step;
      },
    },
    stepCount: {
      get() {
        return this.$store.state.stepCount;
      },
    },
  },
  mounted() { },
  data() {
    return {
      toast: "",
      isToast: false,
    };
  },
  methods: {
    setLoading(status) {
      this.isLoading = status;
      this.$store.commit("updateSubmitLoading", status);
    },
    async postData() {
      this.setCsrf();
      this.setLoading(true);
      await this.axios
        .post(this.$store.state.url, this.$store.state.dataPost)
        .then((Response) => {
          console.log(222,Response);
          let data = Response.data;
          if (data.success){

            this.$store.commit("submitFormStatus", {
              status: true,
              type: "success",
              message: data.message.error,
            });

            if(data.data.actions)
              this.renderAction(data.data.actions)

            window.localStorage.removeItem("vuex")
          }
          else {
            let alerts = {};
            data.data.alerts.map((item) => {
              alerts[item.input] = item.message;
            });
            this.$store.commit("updateAlerts", alerts);
            this.toast = data.message.error;
            this.isToast = true;
          }
        }).catch((Err) => {
          console.log(11122,Err.response)
        } );
      this.setLoading(false);
    },
    async changeStep(newStep, isBack = false) {
      if (isBack) {
        this.$store.commit("updateStep", newStep);
        return;
      }
      this.setCsrf();
      await this.axios
        .post(
          this.$store.state.url + "/validate?page=" + this.step,
          this.$store.state.dataPost
        )
        .then((Response) => {
          let data = Response.data;
          if (data.success) {
            this.$store.commit("updateStep", newStep);
            this.$store.commit("updateAlerts", {});
            if (data.data.pages)
              this.$store.commit("updatePages",data.data.pages);
            
          } else {
            let alerts = {};
            console.log("ERR", data.message.error);
            data.data.alerts.map((item) => {
              alerts[item.input] = item.message;
            });
            this.$store.commit("updateAlerts", alerts);
            this.toast = data.message.error;
            this.isToast = true;
          }
        });
    },
    setCsrf() {
      this.$store.commit("updateDataPostByIndex", {
        index : "csrf",
        val : window.csrf
      });
      this.$store.commit("updateDataPostByIndex", {
        index : "hiddenValue",
        val : window.hiddenValue
      });
    },
    renderAction(actions){
      for(let item in actions){
        switch(item){
          case 'redirect': window.location.href= actions[item].url; break;
        }
      }
    }
  },
};
</script>
